<template lang="pug">
  div.modal-bg(@click="closeModal")
      div.upgrade-upper-master-modal(@click.stop)
          div
              p.mb-0 初期設定が完了していません。
                span#modal-close(@click="closeModal")
          div
              p.mb-0 SiteLeadをご利用いただくには、<br> 計測タグの設置と、Webサイトの登録が必要です。<br>（所要時間5分）
              a.mb-2(href="/users/tag_domains") 計測タグとWebサイトの登録はこちら
              a.mb-2(href="/users/contacts") 初期設定の無料サポートはこちら
  </template>

  <script>
import Vue from "vue";
export default {
    methods: {
        closeModal() {
            this.$emit('close-modal'); // 親コンポーネントへイベントを通知
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
